/** Stable cache keys for inbox-related GET thunks (dedupe identical in-flight / repeat loads). */

export function normalizeIdList(ids) {
  if (!Array.isArray(ids)) return []
  const seen = new Set()
  const out = []
  for (const id of ids) {
    if (id == null || String(id).trim() === "") continue
    const key = String(id)
    if (seen.has(key)) continue
    seen.add(key)
    out.push(key)
  }
  return out.sort()
}

/** alert-users / alert-groups accept one client id per request. */
export function resolveSingleAlertClientId({ clientId, clientIds } = {}) {
  if (clientId != null && String(clientId).trim() !== "") {
    const n = Number(clientId)
    return Number.isFinite(n) ? n : null
  }
  const list = normalizeIdList(clientIds)
  if (list.length === 0) return null
  const n = Number(list[0])
  return Number.isFinite(n) ? n : null
}

export function buildAlertAssigneesFetchKey(payload = {}) {
  const id = resolveSingleAlertClientId(payload)
  return id != null ? String(id) : ""
}

export function hasAlertAssigneesFetchPayload(payload) {
  return resolveSingleAlertClientId(payload) != null
}

export function buildMonitoringScheduleFetchKey({ clientId, organizationId } = {}) {
  if (clientId != null && String(clientId).trim() !== "") {
    return `client:${String(clientId)}`
  }
  if (organizationId != null && String(organizationId).trim() !== "") {
    return `org:${String(organizationId)}`
  }
  return ""
}
